import $api from "@/frontend/shared/api/axios";
import { CreatePipelineSchema } from "@/libs/models/pipelines";

export async function patchRenamePipeline({ id, name }: { id: number; name: string }) {
  const body = {
    name
  };
  const res = await $api.patch(`/pipelines/${id}`, CreatePipelineSchema.parse(body));
  return res.data.data;
}
